<template>
	<yw-modal
		:visible="visible"
		@cancel="cancel"
		@ok="ok"
		v-bind="modalConfig"
		class="transferModal"
	>
		<a-form-model :model="form" :rules="rule" ref="transferModalForm">
			<a-form-model-item
				labelAlign="left"
				label="资源池"
				prop="resourcePoolValue"
				required
				class="pool"
			>
				<a-cascader
					:options="resourcePoolList"
					change-on-selec
					v-model="form.resourcePoolValue"
					style="flex: 0.6"
					placeholder="请选择资源池"
					allowClear
					@change="value => changeTransferData('pool', value)"
				/>
				<a-button icon="filter" @click="showIpModal">批量搜索</a-button>
			</a-form-model-item>
			<a-form-model-item
				:labelCol="{ span: 2 }"
				labelAlign="left"
				prop="resourceTypeValue"
				class="category"
				v-if="isShowTypeRelated"
			>
				<div class="left">
					<a-select
						style="min-width: 88px"
						placeholder="请选择"
						class="selectType"
						:options="typeOpts"
						v-model="form.resourceType"
						@change="changeType"
					/>
					<!-- 服务树模式 -->
					<a-cascader
						v-if="form.resourceType === 'serviceTree'"
						:options="serviceTreeList"
						change-on-selec
						v-model="form.resourceTypeValue"
						placeholder="请选择服务树节点"
						allowClear
						:show-search="true"
						@change="value => changeTransferData('resourceType', value)"
					/>
					<!-- 项目描述模式 -->
					<a-select
						v-else-if="form.resourceType === 'projectDesc'"
						@change="value => changeTransferData('resourceType', value)"
						allowClear
						showSearch
						placeholder="请输入项目描述"
						:options="descsriptionList"
						@search="fetchApi"
						:filterOption="false"
						v-model="form.resourceTypeValue"
					>
						<template slot="notFoundContent">
							<a-spin v-if="!descsriptionList.length > 0" size="small" />
							<a-empty v-else />
						</template>
					</a-select>
					<!-- 客户描述 -->
					<a-select
						v-else-if="form.resourceType === 'customerDesc'"
						@change="value => changeTransferData('resourceType', value)"
						allowClear
						showSearch
						placeholder="请输入客户描述"
						:options="descsriptionList"
						@search="fetchApi"
						:filterOption="false"
						v-model="form.resourceTypeValue"
					>
						<template slot="notFoundContent">
							<a-spin v-if="!descsriptionList.length > 0" size="small" />
							<a-empty v-else />
						</template>
					</a-select>
				</div>
				<div v-if="form.resourceType === 'serviceTree' && isShowBindBtn">
					<a-checkbox :checked="ServeCheckedStatus" @change="bindService"
						>绑定服务</a-checkbox
					>
					<a-tooltip placement="top" title="所选资源随服务下挂载资源实时更新">
						<a-icon type="question-circle" />
					</a-tooltip>
				</div>
			</a-form-model-item>
			<a-form-model-item
				:labelCol="{ span: 2 }"
				labelAlign="left"
				prop="selectedKeys"
			>
				<a-transfer
					:list-style="{
						width: '45%',
						height: '300px',
					}"
					:filterOption="filterOption"
					@change="handleChange"
					@selectChange="handleSelectChange"
					v-bind="transferConfig"
				>
					<span slot="notFoundContent"> 暂无数据 </span>
				</a-transfer>
			</a-form-model-item>
		</a-form-model>
		<BatchSelectIP :visible.sync="ipModalShow" @confirm="getIpList" />
	</yw-modal>
</template>

<script>
import BatchSelectIP from "./BatchSelectIP.vue";
// type分类初始配置
const typeOpts = [
	{
		label: "服务树",
		value: "serviceTree",
	},
	{
		label: "项目描述",
		value: "projectDesc",
	},
	{
		label: "客户描述",
		value: "customerDesc",
	},
];
// transfer默认配置
const transferConfig = {
	showSearch: true,
	showSelectAll: true,
	showArrow: true,
	disabled: false,
	titles: ["资源实列", "目标资源"],
	searchPlaceholder: "请输入搜索内容",
	render: item => `${item.title || item.description}`,
	targetKeys: [],
	selectedKeys: undefined,
	dataSource: [],
};
// modal弹框配置
const modalConfig = {
	title: "选择资源",
	width: 700,
};
export default {
	name: "YwTransferModal",
	components: {
		BatchSelectIP,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		resourcePoolList: {
			type: Array,
			default: () => [],
		},
		resourcePoolValue: {
			type: Array,
			default: () => [],
		},
		resourceType: {
			type: String,
			default: "serviceTree",
		},
		resourceTypeList: {
			type: Array,
			default: () => [],
		},
		resourceTypeValue: {
			type: [Array, String],
			default: () => [],
		},
		modalProps: {
			type: Object,
			default: () => ({}),
		},
		transferProps: {
			type: Object,
			default: () => ({}),
		},
		isShowTypeRelated: {
			type: Boolean,
			default: false,
		},
		isShowBindBtn: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: {},
			visible: false,
			typeOpts,
			tempTransferDataSource: [],
			serviceTreeList: [],
			descsriptionList: [],
			transferConfig,
			modalConfig,
			ipModalShow: false,
			ServeCheckedStatus: false,
		};
	},
	computed: {
		rule() {
			return {
				resourcePoolValue: [{ required: true, message: "请选择资源池" }],
			};
		},
	},

	watch: {
		show(val) {
			// console.log(val, "val");
			this.visible = val;
		},
		resourcePoolValue(val) {
			this.form.resourcePoolValue = val;
		},
		// 分类list
		resourceTypeList(newVal) {
			// 服务树list
			if (this.form.resourceType === "serviceTree" || !this.form.resourceType) {
				this.serviceTreeList = newVal || [];
				// 描述list
			} else {
				this.descsriptionList = newVal || [];
			}
		},
		modalProps(val) {
			this.modalConfig = {
				...this.modalConfig,
				...val,
			};
		},
		transferProps: {
			deep: true,
			immediate: true,
			handler(val) {
				this.transferConfig = {
					...this.transferConfig,

					...val,
				};
				if (val.visible) {
					delete this.transferConfig.visible;
				}
				this.tempTransferDataSource = this.transferConfig.dataSource;
				console.log(this.tempTransferDataSource);
			},
		},
	},
	created() {
		// 初始化
		this.form = this.isShowTypeRelated
			? {
					resourcePoolValue: this.resourcePoolValue,
					resourceType: this.resourceType,
					resourceTypeValue: this.resourceTypeValue,
					selectedKeys: this.transferConfig.selectedKeys || [],
			  }
			: {
					resourcePoolValue: this.resourcePoolValue,
					selectedKeys: this.transferConfig.selectedKeys || [],
			  };
		this.transferConfig = {
			...this.transferConfig,
			...this.transferProps,
		};
		this.modalConfig = {
			...this.modalConfig,
			...this.modalProps,
		};
		if (this.resourceType === "serviceTree") {
			this.serviceTreeList = this.resourceTypeList || [];
		} else {
			this.descsriptionList = this.resourceTypeList || [];
		}
	},
	methods: {
		// changeType
		changeType(key) {
			this.form.resourceTypeValue = key === "serviceTree" ? [] : undefined;
			this.descsriptionList = [];
			this.transferConfig.disabled = false;
			this.transferConfig.targetKeys = [];
			this.transferConfig.selectedKeys = [];
		},
		// 模糊搜索描述列表
		fetchApi(value) {
			// console.log(value, "value");
			value.trim() &&
				this.$emit("updateTypeList", {
					key: value,
					type: this.form.resourceType,
				});
		},
		// 穿梭
		handleChange(targetKeys, direction, moveKeys) {
			this.transferConfig.targetKeys = targetKeys;
			this.form.selectedKeys = targetKeys;
		},
		// 穿梭框选中
		handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
			this.transferConfig.selectedKeys = [
				...sourceSelectedKeys,
				...targetSelectedKeys,
			];
		},
		// 取消
		cancel() {
			this.$emit("update:show", false);
			this.$refs.transferModalForm.resetFields();
			this.transferConfig.selectedKeys = [];
			this.transferConfig.targetKeys = [];
			this.form.resourceType = "serviceTree";
			this.form.resourceTypeValue = [];
			this.transferConfig.disabled = false;
		},
		// 提交
		ok() {
			this.$refs.transferModalForm.validate(valid => {
				// console.log(this.form, "form");
				if (valid) {
					const result = { ...this.form };
					this.$emit("confirm", result);
					this.cancel();
				}
			});
		},
		// 切换typeValue，更换TransferData
		changeTransferData(type, value) {
			// console.log("updateTransferData", {
			// 	key: value,
			// 	type: type,
			// });
			this.$emit("updateTransferData", {
				key: value,
				type: type,
			});
		},
		// 绑定服务
		bindService(e) {
			e.preventDefault();
			if (this.$listeners.handleBindService) {
				this.$emit("handleBindService", e.target.checked);
			} else {
				this.ServeCheckedStatus = e.target.checked;
				this.transferConfig.disabled = e.target.checked;
			}
		},
		// ip集合选中--批量确定
		getIpList(value = []) {
			const res = this.transferConfig.dataSource.reduce((sum, cur) => {
				const resultArr = [];
				return sum.concat(
					value.some(it => it === (cur.title || cur.description))
						? cur.key
						: [],
				);
			}, []);
			this.transferConfig.selectedKeys = res;
		},
		// 批量搜索显示
		showIpModal() {
			this.ipModalShow = true;
		},
		filterOption(inputValue, option) {
			return option.title
				? inputValue.split(",").some(it => option.title.indexOf(it) > -1)
				: inputValue.split(",").some(it => option.description.indexOf(it) > -1);
		},
	},
};
</script>

<style lang="less" scoped>
.transferModal {
	/deep/ .ant-form {
		width: 100%;
		.ant-form-item-control-wrapper {
			flex: 1;
		}
		.ant-row.ant-form-item {
			width: 100%;
			display: flex;
			margin-bottom: 20px !important;
			.ant-form-item-label {
				line-height: 30px;
			}
			.ant-form-item-children {
				width: 100%;
				display: flex;
				align-items: center;
			}
			&.pool {
				.ant-btn {
					margin-left: 10px;
				}
				.ant-form-item-children {
					justify-content: space-between;
				}
			}
			&.category {
				.left {
					flex: 0.7;
					display: flex;
					.ant-select-selection,
					.ant-cascader-input {
						border-radius: 0 4px 4px 0;
					}
					.selectType {
						cursor: pointer;
						&.ant-select {
							&.ant-select-focused,
							&.ant-select-open {
								border-color: dadada;
								color: #1890ff;
							}
							width: 100px;
							border-radius: 4px 0 0 4px;
							.ant-select-selection {
								box-shadow: none;
								background: #eee;
								border-radius: 4px 0 0 4px;
								border: 1px solid #dadada;
								border-right: 0;
								-webkit-transition: all 0.3s;
								transition: all 0.3s;
								&:hover {
									border-color: #dadada;
								}
							}
						}
					}
				}

				.ant-form-item-children {
					gap: 20px;
				}
				&:nth-child {
					flex-shrink: 0;
				}
			}

			.ant-transfer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;
				.ant-transfer-operation .ant-btn {
					&:first-child {
						margin-bottom: 30px;
					}
					border-radius: 100%;
				}
			}
		}
	}
}
</style>
